import React from "react";
import * as moment from "moment";
import history from "./history";
import LangContext, { i18n } from "modules/shared/context/langContext";

export const autoGenKey = (perfix) =>
  `${perfix}-${Math.random().toString(36).substring(7)}-${Math.ceil(
    Math.random() * 1000
  )}}`;

export const checkEmptyJson = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const checkUnauthorized = (fn, action) => {
  history.push("/");
  return fn;
};

export const checkPermissions = (data, matching_name, actions) => {
  let action = true;
  if (typeof data === "string") {
    data = JSON.parse(data || "[]");
  }
  if (!Array.isArray(data)) {
    return false;
  }
  let permissions = data.filter(function (ele) {
    return ele.matching_name === matching_name && parseInt(ele[actions]) === 1;
  });

  if (permissions.length === 0) {
    action = false;
  } else {
    action = true;
  }

  return action;
};

export const hasPermission = (permissions, matchingName, actionName) => {
  let canAccess = permissions.find((ele) => {
    return (
      ele.matching_name === matchingName && parseInt(ele[actionName]) === 1
    );
  });

  if (matchingName === "") {
    canAccess = true;
  } else if (typeof canAccess == "undefined") {
    canAccess = false;
  } else {
    canAccess = true;
  }

  return canAccess;
};

export const helper_changeNumberStatusToTextStatus = (
  number,
  arrKeyWithValue
) => arrKeyWithValue[number.toString()];

export const helper_convertDateformat = (
  dateStr,
  sourceFormat,
  resultFormat
) => {
  let result = "";
  if (dateStr === null) return dateStr;
  if (dateStr.length > 4 && dateStr !== "")
    result = moment(dateStr, sourceFormat).format(resultFormat);
  else if (dateStr === "now") result = "now";
  return result;
};

export const isNumber = (n) => {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
};

export const numberFormat = (number, decimal = 2) => {
  if (typeof number !== "string" && typeof number !== "number") return;
  if (number === "" || isNaN(number)) number = 0;
  return parseFloat(removeComma(number))
    .toFixed(decimal)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const removeComma = (number) => {
  return number.toString().replace(/,/g, "");
};

export const translate = (key, cateKey, lang) => {
  if (typeof lang !== "undefined") {
    return i18n[lang][cateKey][key];
  } else {
    return (
      <LangContext.Consumer>{(val) => val[cateKey][key]}</LangContext.Consumer>
    );
  }
};

export const updateObjectInArray = (array, action, key) => {
  return array.map((item) => {
    if (item[key] !== action[key]) {
      // This isn't the item we care about - keep it as-is
      return item;
    }

    let newitem = Object.assign({}, item, action);
    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...newitem,
    };
  });
};

export const isEmptyString = (value) => {
  if (typeof value === "undefined") return true;
  return (
    value === null || value === "" || value === "null" || value === "undefined"
  );
};

export const changeToBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (parseInt(value) === 0) return false;
  else if (parseInt(value) === 1) return true;
  return false;
};

export const dummyRequest = ({ file, onSuccess }) => {
  var reader = new window.FileReader();
  reader.readAsDataURL(file);
  reader.onload = (...args) => {
    onSuccess("done", file);
  };
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getBoundary = (data) => {
  let latArry = [];
  let lngArry = [];

  for (let j = 0; j < data.length; j++) {
    latArry.push(parseFloat(data[j].lat));
    lngArry.push(parseFloat(data[j].lon));
  }

  let minLat = Math.min.apply(null, latArry);
  let maxLat = Math.max.apply(null, latArry);

  let minLon = Math.min.apply(null, lngArry);
  let maxLon = Math.max.apply(null, lngArry);

  return { minLon, minLat, maxLon, maxLat };
};

export const getCenterOfBoundary = (boundary) => {
  // ตรวจสอบว่ามีข้อมูลหรือไม่ (Boundary จะเป็น {0, 0, 0, 0} หากไม่มีข้อมูล)
  if (boundary.minLat === 0 && boundary.maxLat === 0 && boundary.minLon === 0 && boundary.maxLon === 0) {
    if (!boundary || boundary.length === 0) {
      return { lat: 0, lon: 0 };
    }
  }

  // คำนวณค่าเฉลี่ยเพื่อหาจุดศูนย์กลาง
  const centerLat = (boundary.minLat + boundary.maxLat) / 2;
  const centerLon = (boundary.minLon + boundary.maxLon) / 2;

  return { lat: parseFloat(centerLat).toFixed(6), lon: parseFloat(centerLon).toFixed(6) };
};


export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 || 0,
      v = c === "x" ? r : r && 0x3 | 0x8;
    return v.toString(16);
  });
};

export const countSplitWorkArray = (data) => {
  let count = 0.0;
  data.map((vl) => {
    count = count + parseFloat(vl.value);
    return true;
  });

  return parseFloat(count);
};

export const countRefund = (data) => {
  let count = 0.0;
  data.map((vl) => {
    count = count + parseFloat(vl.min_order_fee_price);
    return true;
  });
  return count;
};

export const splitSaleOrderDetail = (data) => {
  if (typeof data == "undefined") {
    return ""
  }

  let split_detail = data.split("\n");
  return split_detail[0] + " " + split_detail[1] + " " + split_detail[2];
};

export const getSaleorderStatus = (text) => {
  let status = ""
  switch (text) {
    case 1: status = "รอชำระเงิน"; break;
    case 2: status = "ชำระเงินแล้ว"; break;
    case 3: status = "รอจัดส่ง"; break;
    case 4: status = "สำเร็จแล้ว"; break;
    case 5: status = "ยกเลิก"; break;
    case 6: status = "หมดเวลาชำระเงิน"; break;
    default:
      break;
  }
  return status
}

export const checkValueStringNullForDisplay = (value) => {
  let text = "";
  if (value != null) {
    text = value;
  }
  return text;
};
export const abbrDeliveryType = (val) => {
  switch (val) {
    case "ส่งด่วนภายใน 3 ชั่วโมง":
      return "ด่วน  3 ชั่วโมง";
    case "ส่งด่วนภายในวัน":
      return "ภายในวัน";
    case "จองล่วงหน้า":
      return "ล่วงหน้า";
    default:
      break;
  }
  return val;
};
